import { EVolumeType } from 'features/index/model/EVolumeType';
import { IQueueParamProps } from '../../../models/interfaces/IQueueParamProps';
import { QueueUploadSeismicParam } from './QueueUploadSeismicParam';

export function QueueUploadSeismic2DParam({ onParamsChange, initialValues }: IQueueParamProps) {
    return <QueueUploadSeismicParam volumeType={EVolumeType.Seismic2D} onParamsChange={onParamsChange} initialValues={initialValues} />;
}
